import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import Button, { ButtonProps } from '../../atoms/Button';
import Overlay from '../../atoms/Overlay';
import Surface from '../../atoms/Surface';

import styles from './ActionsButton.module.scss';

export interface Props
  extends Omit<ButtonProps, 'type' | 'children' | 'onSelect'> {
  label?: string;
  icon?: FontAwesomeIconProps['icon'];
  children: (dismiss: () => void) => React.ReactNode;
}

export const ActionsButton = ({
  className,
  label = '',
  size = 'md',
  icon = faEllipsisVertical,
  children,
  ...htmlButtonProps
}: Props): React.ReactElement => {
  const [show, setShow] = React.useState(false);
  const btnRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <div className={className} ref={btnRef}>
      <Button
        className={styles.button}
        variant="outline"
        type="button"
        size={size}
        icon={icon}
        aria-label="mais ações"
        {...htmlButtonProps}
        // Leave this at the bottom, otherwise, Storybook overwrites this value
        onClick={() => setShow(!show)}
      >
        {label}
      </Button>

      {show && (
        <Overlay
          show={show}
          placement="bottom-start"
          target={btnRef.current}
          onHide={() => setShow(false)}
          tooltip
        >
          <Surface
            className={styles.popover}
            backgroundColor="grayLight3"
            padding="xs"
          >
            {children?.(() => setShow(false))}
          </Surface>
        </Overlay>
      )}
    </div>
  );
};

export default ActionsButton;
